import * as Diagram from "../../../../components/diagram";

const levelColumns = [
  {
    key: "BMI",
    isNumber: true,
    isSum: true,
  },
];

const groupOrders = {
  每次分鐘: {
    "10分鐘": 0,
    "20分鐘": 1,
    "30分鐘": 2,
    "40分鐘": 3,
    "50分鐘": 4,
    "60分鐘": 5,
    "61-90分鐘": 6,
    "不知道、拒答": 7,
  },
};

export const ExerciseHabitsMinutesToBMI = {
  label: "運動習慣每次分鐘 vs BMI",
  key: "ExerciseHabitsMinutesToBMI",
  path: "BMI/ExerciseHabitsMinutesToBMI",
  api: "TCS_V_BMISportQ83V",
  render: (options) => <Diagram.BMI.ExerciseHabitsMinutesToBMI {...options} />,
  isPercent: true,
  isColSum: true,
  isRowSum: true,
  isGroup: true,
  groupOrders,
  groupColumns: [
    {
      key: "每次分鐘",
      field: "每次分鐘",
      header: "",
    },
  ],
  levelColumns,
  columns: [],
};
